import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { CoreModule } from '../core/core.module';
import { SeraOldFooterBarCriterionComponent } from './old-ui/sera-old-footer-bar-criterion/sera-old-footer-bar-criterion.component';
import { SeraOldFooterBarComponent } from './old-ui/sera-old-footer-bar/sera-old-footer-bar.component';
import { SeraOldSubheaderBarComponent } from './old-ui/sera-old-subheader-bar/sera-old-subheader-bar.component';
import { SeraOldVersionDropdownComponent } from './old-ui/sera-old-version-dropdown/sera-old-version-dropdown.component';
import { FilterButtonBasedOnDisplayModePipe } from './pipes/filter-icon-based-on-display-mode.pipe';
import { FirstNItemsPipe } from './pipes/first-n-items.pipe';
import { SeraAccordionComponent } from './ui/sera-accordion/sera-accordion.component';
import { SeraAttachmentsComponent } from './ui/sera-attachments/sera-attachments.component';
import { SeraAuditComponent } from './ui/sera-audit/sera-audit.component';
import { SeraButtonComponent } from './ui/sera-button/sera-button.component';
import { SeraCheckboxComponent } from './ui/sera-checkbox/sera-checkbox.component';
import { SeraConfirmationDialogComponent } from './ui/sera-confirmation-dialog/sera-confirmation-dialog.component';
import { SeraDraggableTableComponent } from './ui/sera-draggable-table/sera-draggable-table.component';
import { SeraDropdownComponent } from './ui/sera-dropdown/sera-dropdown.component';
import { SeraDwsmSettingsComponent } from './ui/sera-dwsm-settings/sera-dwsm-settings.component';
import { SeraFooterBarComponent } from './ui/sera-footer-bar/sera-footer-bar.component';
import { SeraIconComponent } from './ui/sera-icon/sera-icon.component';
import { SeraInputNumberComponent } from './ui/sera-input-number/sera-input-number.component';
import { SeraInputTextAreaComponent } from './ui/sera-input-text-area/sera-input-text-area.component';
import { SeraInputTextComponent } from './ui/sera-input-text/sera-input-text.component';
import { SeraInvalidLabelComponent } from './ui/sera-invalid-label/sera-invalid-label.component';
import { SeraItemsCountComponent } from './ui/sera-items-count/sera-items-count.component';
import { SeraLabelValueComponent } from './ui/sera-label-value/sera-label-value.component';
import { SeraLoadingWheelComponent } from './ui/sera-loading-wheel/sera-loading-wheel.component';
import { SeraMultiselectComponent } from './ui/sera-multiselect/sera-multiselect.component';
import { SeraPageHeaderComponent } from './ui/sera-page-header/sera-page-header.component';
import { SeraPopupComponent } from './ui/sera-popup/sera-popup.component';
import { SeraProgressBarComponent } from './ui/sera-progress-bar/sera-progress-bar.component';
import { SeraRadioButtonComponent } from './ui/sera-radio-button/sera-radio-button.component';
import { SeraRiShiComponent } from './ui/sera-ri-shi/sera-ri-shi.component';
import { SeraTabHolderComponent } from './ui/sera-tab-holder/sera-tab-holder.component';
import { SeraTableComponent } from './ui/sera-table/sera-table.component';
import { SeraToastComponent } from './ui/sera-toast/sera-toast.component';
import { SeraToggleComponent } from './ui/sera-toggle/sera-toggle.component';
import { SeraTreeComponent } from './ui/sera-tree/sera-tree.component';
import { SeraUserSearchPopupComponent } from './ui/sera-user-search/sera-user-search-popup.component';
import { SeraUserSelectComponent } from './ui/sera-user-select/sera-user-select.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { SeraHeaderBarComponent } from './ui/sera-header-bar/sera-header-bar.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SeraImageComponent } from 'src/app/shared/ui/sera-image/sera-image.component';
import { SeraImageContainerComponent } from './ui/sera-image-container/sera-image-container.component';
import { SeraLineChartComponent } from './ui/sera-line-chart/sera-line-chart.component';
import { SeraToggleButtonComponent } from './ui/sera-toggle-button/sera-toggle-button.component';
import { SeraHorizontalLineComponent } from './ui/sera-horizontal-line/sera-horizontal-line.component';
import { Cr7ForceCaseImagesComponent } from '../analysis/cr7/cr7-kim/force-case-popup/cr7-force-case-images/cr7-force-case-images.component';
import { Cr7ForceCasePopupComponent } from '../analysis/cr7/cr7-kim/force-case-popup/cr7-force-case-popup.component';
import { SeraInfoTextComponent } from './ui/sera-info-text/sera-info-text.component';
import { SeraInputsAndSliderComponent } from './ui/sera-inputs-and-slider/sera-inputs-and-slider.component';
import { DensitySharedModule } from './density-ui/density-shared.module';
import { SeraTimeProgressBarComponent } from './ui/sera-time-progress-bar/sera-time-progress-bar.component';
import { DsHintModule, DsBadgeModule, DsSwitchModule, DsButtonModule, DsMessageModule } from '@bmw-ds/components';
import { SeraRangeSliderComponent } from './ui/sera-range-slider/sera-range-slider.component';
import { SeraRiValueComponent } from './ui/sera-ri-value/sera-ri-value.component';
import { OverlayModule } from 'primeng/overlay';
import { SeraRecommendedForceMeterComponent } from './ui/sera-recommended-force-meter/sera-recommended-force-meter.component';
import { SeraForceCaseDirectionComponent } from './ui/sera-force-case-direction/sera-force-case-direction.component';
import { SeraImageSelectorComponent } from './ui/sera-image-selector/sera-image-selector.component';
import { SeraShiComponent } from './ui/sera-shi/sera-shi.component';
import { SearchPageLayoutComponent } from './ui/search-page-layout/search-page-layout.component';
import { OverviewTableComponent } from '../analysis/overview/overview-table/overview-table.component';
import { HeaderDataTableComponent } from './ui/header-data-table/header-data-table.component';
import { PrintPopupComponent } from '../analysis/popups/print-popup/print-popup.component';
import { PrintComponent } from '../analysis/print/print.component';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        SeraPageHeaderComponent,
        SeraTabHolderComponent,
        SeraDropdownComponent,
        SeraRadioButtonComponent,
        SeraTableComponent,
        SeraCheckboxComponent,
        SeraIconComponent,
        SeraUserSelectComponent,
        SeraLoadingWheelComponent,
        SeraProgressBarComponent,
        SeraButtonComponent,
        SeraInputTextComponent,
        SeraToggleComponent,
        SeraPopupComponent,
        SeraMultiselectComponent,
        SeraFooterBarComponent,
        SeraInputNumberComponent,
        SeraAuditComponent,
        SeraItemsCountComponent,
        SeraOldSubheaderBarComponent,
        SeraInputTextAreaComponent,
        SeraItemsCountComponent,
        SeraAccordionComponent,
        SeraTreeComponent,
        SeraRiShiComponent,
        SeraRiValueComponent,
        SeraOldFooterBarComponent,
        SeraOldFooterBarCriterionComponent,
        SeraToastComponent,
        SeraConfirmationDialogComponent,
        SeraUserSearchPopupComponent,
        FilterButtonBasedOnDisplayModePipe,
        FirstNItemsPipe,
        SeraOldVersionDropdownComponent,
        SeraInvalidLabelComponent,
        SeraAttachmentsComponent,
        SeraDraggableTableComponent,
        SeraLabelValueComponent,
        SeraDwsmSettingsComponent,
        SeraHeaderBarComponent,
        SeraImageComponent,
        SeraInfoTextComponent,
        SeraInputsAndSliderComponent,
        SeraTimeProgressBarComponent,
        SeraLineChartComponent,
        SeraImageContainerComponent,
        SeraLineChartComponent,
        SeraToggleButtonComponent,
        SeraHorizontalLineComponent,
        SeraInfoTextComponent,
        SeraRangeSliderComponent,
        Cr7ForceCaseImagesComponent,
        Cr7ForceCasePopupComponent,
        SeraHorizontalLineComponent,
        SeraRecommendedForceMeterComponent,
        SeraForceCaseDirectionComponent,
        SeraImageSelectorComponent,
        SeraShiComponent,
        SearchPageLayoutComponent,
        OverviewTableComponent,
        HeaderDataTableComponent,
        PrintPopupComponent,
        PrintComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        CoreModule,
        TranslateModule,
        TableModule,
        InputTextModule,
        RippleModule,
        ButtonModule,
        CheckboxModule,
        ToolbarModule,
        SliderModule,
        ToggleButtonModule,
        SelectModule,
        MultiSelectModule,
        DialogModule,
        InputNumberModule,
        RadioButtonModule,
        ToastModule,
        TabsModule,
        TreeModule,
        AccordionModule,
        ToggleSwitchModule,
        ConfirmDialogModule,
        PopoverModule,
        ProgressSpinnerModule,
        DragDropModule,
        DensitySharedModule,
        DsHintModule,
        DsBadgeModule,
        DsButtonModule,
        ProgressBarModule,
        ChartModule,
        OverlayModule,
        DsSwitchModule,
        TooltipModule,
        RouterModule,
        DsMessageModule
    ],
    exports: [
        SeraMultiselectComponent,
        SeraPageHeaderComponent,
        SeraTabHolderComponent,
        SeraTableComponent,
        SeraInputTextComponent,
        SeraDropdownComponent,
        FormsModule,
        ReactiveFormsModule,
        SeraCheckboxComponent,
        SeraPopupComponent,
        CommonModule,
        ProgressSpinnerModule,
        SeraButtonComponent,
        SeraFooterBarComponent,
        SeraInputNumberComponent,
        ToastModule,
        SeraAuditComponent,
        SeraItemsCountComponent,
        SeraOldSubheaderBarComponent,
        SeraRadioButtonComponent,
        SeraInputTextAreaComponent,
        SeraItemsCountComponent,
        SeraInvalidLabelComponent,
        SeraAccordionComponent,
        SeraTreeComponent,
        SeraRiShiComponent,
        SeraRiValueComponent,
        SeraOldFooterBarComponent,
        SeraToggleComponent,
        SeraOldFooterBarCriterionComponent,
        SeraToastComponent,
        SeraIconComponent,
        ConfirmDialogModule,
        SeraConfirmationDialogComponent,
        SeraUserSearchPopupComponent,
        TooltipModule,
        SeraOldVersionDropdownComponent,
        FilterButtonBasedOnDisplayModePipe,
        FirstNItemsPipe,
        SeraAttachmentsComponent,
        SeraDraggableTableComponent,
        SeraLabelValueComponent,
        SeraProgressBarComponent,
        SeraHeaderBarComponent,
        SeraDwsmSettingsComponent,
        ChartModule,
        SeraImageComponent,
        SeraLineChartComponent,
        SeraImageContainerComponent,
        SeraLineChartComponent,
        SeraToggleButtonComponent,
        SeraHorizontalLineComponent,
        SeraInfoTextComponent,
        SeraInputsAndSliderComponent,
        SeraTimeProgressBarComponent,
        SeraRangeSliderComponent,
        Cr7ForceCaseImagesComponent,
        Cr7ForceCasePopupComponent,
        SeraHorizontalLineComponent,
        SeraRecommendedForceMeterComponent,
        SeraForceCaseDirectionComponent,
        SeraImageSelectorComponent,
        SeraShiComponent,
        SearchPageLayoutComponent,
        OverviewTableComponent,
        HeaderDataTableComponent,
        PrintPopupComponent,
        PrintComponent,
        DensitySharedModule
    ],
    providers: [DatePipe, DecimalPipe, ConfirmationService]
})
export class SharedModule {}
